import PersonalInfo from "./personal-info";

export default PersonalInfo;
